import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RecentCallsList = ({ onRedial, onViewDetails }) => {
  const [selectedDisposition, setSelectedDisposition] = useState('');

  const recentCalls = [
    {
      id: 1,
      customerName: "Ahmet Yılmaz",
      phoneNumber: "+90 532 123 4567",
      callType: "Gelen",
      duration: "05:23",
      timestamp: new Date(Date.now() - 1800000),
      status: "Tamamlandı",
      disposition: "Satış",
      priority: "Yüksek"
    },
    {
      id: 2,
      customerName: "Fatma Demir",
      phoneNumber: "+90 533 987 6543",
      callType: "Giden",
      duration: "12:45",
      timestamp: new Date(Date.now() - 3600000),
      status: "Tamamlandı",
      disposition: "Destek",
      priority: "Orta"
    },
    {
      id: 3,
      customerName: "Mehmet Kaya",
      phoneNumber: "+90 534 555 7890",
      callType: "Gelen",
      duration: "03:12",
      timestamp: new Date(Date.now() - 7200000),
      status: "Cevapsız",
      disposition: "Geri Arama",
      priority: "Düşük"
    },
    {
      id: 4,
      customerName: "Ayşe Özkan",
      phoneNumber: "+90 535 444 3322",
      callType: "Giden",
      duration: "08:56",
      timestamp: new Date(Date.now() - 10800000),
      status: "Tamamlandı",
      disposition: "Bilgi",
      priority: "Orta"
    },
    {
      id: 5,
      customerName: "Ali Şahin",
      phoneNumber: "+90 536 111 2233",
      callType: "Gelen",
      duration: "15:30",
      timestamp: new Date(Date.now() - 14400000),
      status: "Tamamlandı",
      disposition: "Şikayet",
      priority: "Yüksek"
    }
  ];

  const dispositionOptions = [
    { value: '', label: 'Tüm Durumlar' },
    { value: 'Satış', label: 'Satış' },
    { value: 'Destek', label: 'Destek' },
    { value: 'Şikayet', label: 'Şikayet' },
    { value: 'Bilgi', label: 'Bilgi' },
    { value: 'Geri Arama', label: 'Geri Arama' }
  ];

  const formatTime = (date) => {
    return date?.toLocaleTimeString('tr-TR', { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'Tamamlandı':
        return 'bg-green-100 text-green-800';
      case 'Cevapsız':
        return 'bg-red-100 text-red-800';
      case 'Meşgul':
        return 'bg-yellow-100 text-yellow-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'Yüksek':
        return 'bg-red-100 text-red-800';
      case 'Orta':
        return 'bg-yellow-100 text-yellow-800';
      case 'Düşük':
        return 'bg-gray-100 text-gray-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const filteredCalls = selectedDisposition 
    ? recentCalls?.filter(call => call?.disposition === selectedDisposition)
    : recentCalls;

  return (
    <div className="bg-white rounded-lg shadow-subtle border border-slate-200 p-6">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-slate-900">Son Aramalar</h3>
          <p className="text-sm text-slate-600">Bugünkü arama geçmişiniz</p>
        </div>
        <Button
          variant="outline"
          size="sm"
          iconName="RotateCcw"
          iconPosition="left"
        >
          Yenile
        </Button>
      </div>
      {/* Filter */}
      <div className="mb-4">
        <select
          value={selectedDisposition}
          onChange={(e) => setSelectedDisposition(e?.target?.value)}
          className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary"
        >
          {dispositionOptions?.map((option) => (
            <option key={option?.value} value={option?.value}>
              {option?.label}
            </option>
          ))}
        </select>
      </div>
      {/* Calls List */}
      <div className="space-y-3 max-h-96 overflow-y-auto">
        {filteredCalls?.map((call) => (
          <div
            key={call?.id}
            className="border border-slate-200 rounded-lg p-4 hover:bg-slate-50 transition-colors duration-150"
          >
            <div className="flex items-start justify-between mb-3">
              <div className="flex-1">
                <div className="flex items-center space-x-2 mb-1">
                  <h4 className="font-semibold text-slate-900">{call?.customerName}</h4>
                  <span className={`inline-flex items-center px-2 py-1 text-xs font-medium rounded-full ${
                    call?.callType === 'Gelen' ? 'bg-blue-100 text-blue-800' : 'bg-green-100 text-green-800'
                  }`}>
                    <Icon 
                      name={call?.callType === 'Gelen' ? "ArrowDown" : "ArrowUp"} 
                      size={10} 
                      className="mr-1" 
                    />
                    {call?.callType}
                  </span>
                </div>
                <div className="text-sm text-slate-600 mb-2">
                  {call?.phoneNumber}
                </div>
                <div className="flex items-center space-x-4 text-xs text-slate-500">
                  <span className="flex items-center">
                    <Icon name="Clock" size={12} className="mr-1" />
                    {formatTime(call?.timestamp)}
                  </span>
                  <span className="flex items-center">
                    <Icon name="Timer" size={12} className="mr-1" />
                    {call?.duration}
                  </span>
                </div>
              </div>
              
              <div className="text-right space-y-2">
                <div className="flex flex-col space-y-1">
                  <span className={`inline-flex items-center px-2 py-1 text-xs font-medium rounded-full ${getStatusColor(call?.status)}`}>
                    {call?.status}
                  </span>
                  <span className={`inline-flex items-center px-2 py-1 text-xs font-medium rounded-full ${getPriorityColor(call?.priority)}`}>
                    {call?.priority}
                  </span>
                </div>
              </div>
            </div>

            {/* Disposition */}
            <div className="mb-3">
              <span className="inline-flex items-center px-2 py-1 text-xs font-medium rounded-full bg-slate-100 text-slate-800">
                <Icon name="Tag" size={10} className="mr-1" />
                {call?.disposition}
              </span>
            </div>

            {/* Actions */}
            <div className="flex items-center space-x-2">
              <Button
                variant="outline"
                size="xs"
                onClick={() => onRedial(call?.phoneNumber)}
                iconName="Phone"
                iconPosition="left"
              >
                Tekrar Ara
              </Button>
              <Button
                variant="ghost"
                size="xs"
                onClick={() => onViewDetails(call?.id)}
                iconName="Eye"
                iconPosition="left"
              >
                Detaylar
              </Button>
            </div>
          </div>
        ))}
      </div>
      {filteredCalls?.length === 0 && (
        <div className="text-center py-8">
          <Icon name="Phone" size={48} className="mx-auto text-slate-300 mb-4" />
          <p className="text-sm text-slate-600">
            {selectedDisposition ? 'Bu durumda arama bulunamadı' : 'Henüz arama geçmişi yok'}
          </p>
        </div>
      )}
    </div>
  );
};

export default RecentCallsList;